import {useRef} from "react";

export default lazyFunc => {
	const myRef = useRef(undefined);
	if (myRef.current === undefined) {
		myRef.current = lazyFunc();
	}
	return myRef;
};
